import { ActionTile } from '@g17eco/atoms/action-tile/ActionTile';
import { DocumentProps, isFileDocumentProps } from './utils';
import { FlickityWrapper } from '@g17eco/molecules/flickity-wrapper';
import EditButton from '@g17eco/molecules/button/EditButton';
import { DocumentMediaType, InitiativeDocument } from '@g17eco/types/document';

interface Props {
  displayDocuments: InitiativeDocument[];
  currentDocType: DocumentProps;
  initiativeId: string;
  editHandler: (media: InitiativeDocument) => void;
  addDisplayDocument: () => void;
  canEdit: boolean;
}

const options = {
  cellAlign: 'left',
  pageDots: true,
  draggable: true,
  groupCells: true,
};

const MAX_DISPLAYED_FILES = 5;

export const MediaTabContent = (props: Props) => {
  const { displayDocuments, currentDocType, initiativeId, editHandler, addDisplayDocument, canEdit } = props;

  if (displayDocuments.length === 0) {
    if (currentDocType.key === DocumentMediaType.Assurance || !canEdit) {
      return <div className='alert alert-primary mt-4'>There are no files currently available</div>;
    }

    return (
      <ActionTile
        onClick={addDisplayDocument}
        icon={'fa-plus'}
        title='Display media'
        subtitle='Choose from files in your document library'
      />
    );
  }

  if (isFileDocumentProps(currentDocType)) {
    return currentDocType.render(displayDocuments.slice(0, MAX_DISPLAYED_FILES), editHandler, initiativeId, canEdit);
  }

  return (
    <FlickityWrapper disableImagesLoaded={true} reloadOnUpdate={true} options={options}>
      {displayDocuments.slice(0, MAX_DISPLAYED_FILES).map((doc) => {
        return (
          <div key={doc._id}>
            {currentDocType.render(doc)}
            {canEdit ? <EditButton outline={false} onClick={() => editHandler(doc)} className='removeButton' /> : null}
          </div>
        );
      })}
    </FlickityWrapper>
  );
};
